module.exports = __webpack_public_path__ + "img/03.080c8cfb.svg";